import tokens from '@kluein/design-tokens';
import { Box, Button, Text } from '@kluein/klue-ui';
import { useTranslation } from 'react-i18next';

import {
  type DashboardSortType,
  DASHBOARD_SORT_LIMITED_OPTIONS,
  DASHBOARD_SORT_OPTIONS,
} from 'api/endpoints/rivals.types';
import TEST_IDS from 'test-ids';
import TRACKING_IDS from 'tracking-ids';

export type SortContentProps = {
  sort?: string;
  onSelectSort: (sort: DashboardSortType) => void;
  isCurator: boolean;
};

const SortDropContent = ({
  sort: activeSort,
  onSelectSort,
  isCurator,
}: SortContentProps) => {
  const { t } = useTranslation();

  const onGroupSelection = (sort: DashboardSortType) => {
    onSelectSort(sort);
  };

  // Curators get all sort options, consumers get limited options (no cards/battlecards)
  const baseSortOptions = isCurator
    ? DASHBOARD_SORT_OPTIONS
    : DASHBOARD_SORT_LIMITED_OPTIONS;
  const sortOptions = [...baseSortOptions, 'divider', 'companyDefault'];

  return (
    <Box
      gap="hair"
      pad={{
        horizontal: 'medium',
        top: 'large',
        bottom: 'medium',
      }}
      width="medium"
      data-test-id={TEST_IDS.dashboard.filterDrops.sort.dropContent}
    >
      <Text size="small" color={tokens.color.neutral.darkgrey.main}>
        {t('Common:actions.sortBy')}
      </Text>
      {sortOptions.map((sort) => {
        if (sort === 'divider') {
          return (
            <Box
              key={sort}
              flex={{ grow: 1 }}
              background={tokens.color.neutral.lightgrey.main}
              height="hair"
              margin={{ vertical: 'xxsmall' }}
            />
          );
        }

        return (
          <Button
            active={sort === activeSort}
            key={sort}
            label={t(`Dashboard:sort.${sort}`)}
            title={t(`Dashboard:sort.${sort}`)}
            fill
            variant="flat-menu"
            onClick={() => onGroupSelection(sort as DashboardSortType)}
            data-tracking-id={`${TRACKING_IDS.dashboard.filters.sortDrop.itemPrefix}-${sort}`}
          />
        );
      })}
    </Box>
  );
};

export default SortDropContent;
